import React, { useState, useEffect } from "react";
import axios from "axios";
import ItemCard from "../components/ItemCard";
import Footer from "../components/Footer";
import Header from "../components/Header";


const HomePage = ({ toggleMode, mode }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        // const response = await axios.get("http://localhost:4000/data"); 
        const response = await axios.get("/data"); // Fetch from the '/data' endpoint
        setItems(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  return (
    <>
      <Header mode={mode} toggleMode={toggleMode} />
      <main className="homepage mb-3">
        <div className="container px-4 px-md-0">
          <div className="row">
            {loading ? (
              <div className="spinner-overlay">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : items.length === 0 ? (
              <p className="text-center">No items to display.</p>
            ) : (
              items.map((item, index) => (
                <ItemCard key={index} item={item} index={index} />
              ))
            )}
          </div>
        </div>
      </main>
      {!loading && <Footer />}
    </>
  );
};

export default HomePage;
